// extracted by mini-css-extract-plugin
export default {"blog":"BlogItem_blog__krTvb","author":"BlogItem_author__ta30w","info":"BlogItem_info__SLuyX"};